<script>
  import { run } from 'svelte/legacy';

  import { page_count } from "../stores/stores";
  import NavIcon from "./NavIcon.svelte";
  /**
   * @typedef {Object} Props
   * @property {number} [resultsPerPage]
   * @property {number} [totalPages]
   */

  /** @type {Props} */
  let { resultsPerPage = 6, totalPages = $bindable(1) } = $props();

  let lastPage = 0;
  let articles;
  let third = $state(3);
  let fourth = $state(4);
  let fifth = $state(5);
  let end = $derived($page_count * resultsPerPage - 1);
  let start = $derived(end - resultsPerPage + 1);

  totalPages = Math.ceil(totalPages);
  run(() => {
    if ($page_count <= 5) {
      third = 3;
      fourth = 4;
      fifth = 5;
    }
  });
  run(() => {
    if (totalPages && $page_count > totalPages - 4 && totalPages > 5) {
      third = totalPages - 3;
      fourth = totalPages - 2;
      fifth = totalPages - 1;
    }
  });
  run(() => {
    if (totalPages && $page_count > 5 && $page_count <= totalPages - 4) {
      third = $page_count - 2;
      fourth = $page_count - 1;
      fifth = $page_count;
    }
  });

  const onNext = () => {
    $page_count <= totalPages && page_count.increment();
  };
  const onPrevious = () => {
    $page_count > 1 && page_count.decrement();
  };
</script>

<nav class="pagnav">
  {#if $page_count > 1}
    <button onclick={onPrevious}>
      <NavIcon rotate />
    </button>
    <button class="btn-secondary btn-mobile pagnav__btn" onclick={onPrevious}>
      Previous
    </button>
  {:else}
    <button class="pagnav__btn--hide">
      <NavIcon />
    </button>
    <button class="btn-primary btn-mobile pagnav__btn pagnav__btn--hide"
      >Previous</button
    >
  {/if}

  <ul class="pagnav__numbers">
    <!-- 1 -->
    <li class="list-none">
      <button
        onclick={() => {
          page_count.set(1);
        }}
        class={$page_count === 1 ? "link active" : "cursor-pointer"}
      >
        1
      </button>
    </li>
    {#if $page_count > 5}
      <li class="list-none">...</li>
    {:else if totalPages > 1}
      <!-- 2 -->
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(2);
          }}
          class={$page_count === 2 ? "link active" : "cursor-pointer"}
        >
          2
        </button>
      </li>
    {/if}

    <!-- 3 -->
    {#if totalPages > 2}
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(third);
          }}
          class={$page_count === third ? "link active" : "cursor-pointer"}
        >
          {third}
        </button>
      </li>
    {/if}
    <!-- 4 -->
    {#if totalPages > 3}
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(fourth);
          }}
          class={$page_count === fourth ? "link active" : "cursor-pointer"}
        >
          {fourth}
        </button>
      </li>
    {/if}
    <!-- 5 -->
    {#if totalPages > 4}
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(fifth);
          }}
          class={$page_count === fifth ? "link active" : "cursor-pointer"}
        >
          {fifth}
        </button>
      </li>
    {/if}

    {#if ($page_count <= totalPages - 4 && totalPages > 5) || ($page_count < 6 && totalPages > 5)}
      <li class="list-none">...</li>
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(totalPages);
          }}
          class={$page_count === totalPages ? "link active" : "cursor-pointer"}
        >
          {totalPages}
        </button>
      </li>
    {:else if totalPages > 5}
      <li class="list-none">
        <button
          onclick={() => {
            page_count.set(totalPages);
          }}
          class={$page_count === totalPages ? "link active" : "cursor-pointer"}
        >
          {totalPages}
        </button>
      </li>
    {/if}
  </ul>
  {#if $page_count < totalPages}
    <button onclick={onNext}>
      <NavIcon />
    </button>
    <button class="btn-primary btn-mobile pagnav__btn" onclick={onNext}
      >Next</button
    >
  {:else}
    <button class="pagnav__btn--hide">
      <NavIcon />
    </button>
    <button class="btn-primary btn-mobile pagnav__btn pagnav__btn--hide"
      >Next</button
    >
  {/if}
</nav>

<style>
  .pagnav {
	 display: flex;
	 flex-wrap: nowrap;
	 justify-content: space-around;
	 align-items: center;
	 width: 100%;
	 margin-top: auto;
	 margin-bottom: 80px;
}
 @media (min-width: 768px) {
	 .pagnav {
		 justify-content: center;
	}
}
 .pagnav__btn {
	 display: none;
	 min-width: auto !important;
	 margin: 0 40px;
}
 .pagnav__btn--hide {
	 visibility: hidden;
}
 .pagnav__btn--no_outline {
	 outline: none;
}
 @media (min-width: 768px) {
	 .pagnav__btn {
		 display: inline;
	}
}
 .pagnav__numbers {
	 display: flex;
	 list-style: none;
	 margin: 0;
	 padding: 0;
	 flex-wrap: nowrap;
	 align-items: center;
	 margin: 0 5px;
}
 @media (min-width: 768px) {
	 .pagnav__numbers {
		 margin: 0 10px;
	}
}
 .pagnav__numbers li {
	 margin: 0 8px;
}
 @media (min-width: 768px) {
	 .pagnav__numbers li {
		 margin: 0 10px;
	}
}
 .pagnav__numbers li a {
	 display: block;
	 color: #6e6e6e;
	 padding: 0 0.2rem;
	 word-break: normal;
}
 .pagnav__numbers li a:hover {
	 color: #007497;
}
 .pagnav__numbers li a.active {
	 color: #007497;
	 border-bottom: 1px solid #007497;
	 font-weight: 700;
}
 
</style>
